import React, { useEffect, useState } from 'react';
import { Action } from 'redux';
import { hideLoadingIndicator, showLoadingIndicator } from 'redux/modules/api/loadingIndicator/actions';
import { NumbersService } from 'services/numbers/numbers';
import { finalize } from 'rxjs/operators';
import { throwError } from 'rxjs';

const useGetCreditLine = (
	phoneNumber: string,
	accountNumber: string,
	masterNumber: string,
	setLoading: (value: React.SetStateAction<any>) => void,
	dispatch: (action: Action<any>) => Action<any>,
	elRef: React.MutableRefObject<boolean>
): [string, React.Dispatch<React.SetStateAction<string>>, string] => {
	const [creditLimit, setCreditLimit] = useState<string>('');
	const [balance, setBalance] = useState<string>('');

	useEffect(() => {
		if (!!phoneNumber && !!accountNumber && !creditLimit) {
			setLoading((loading: any) => ({ ...loading, limit: true }));
			dispatch(showLoadingIndicator());
			NumbersService.getUsage({
				phoneNumber,
			})
				.pipe(
					finalize(() => {
						dispatch(hideLoadingIndicator());
						if (elRef.current) {
							setLoading((loading: any) => ({ ...loading, limit: false }));
						}
					})
				)
				.subscribe(
					(data) => {
						if (data) {
							const postpaidCreditLimit = data?.balance?.postpaidCreditLimit || 0;
							const postpaidBalance = data?.balance?.postpaidBalance || 0;
							setCreditLimit(String(Math.abs(postpaidCreditLimit)));
							setBalance(String(Math.abs(postpaidCreditLimit - postpaidBalance)));
						}
					},
					(error) => throwError(error)
				);
		}
	}, [masterNumber, phoneNumber, accountNumber, creditLimit, dispatch, elRef, setLoading, balance]);

	return [creditLimit, setCreditLimit, balance];
};
export default useGetCreditLine;
